import axios from "axios";
import { getHeaders, getURl } from "./core";

let url = `${getURl()}/attendance/v1`;
export function getMany({
    offset = 0, 
    limit = 15, 
    filter = '', 
    search = '', 
    status, 
    rangFilter = "",
}) {
    let attendanceUrl = `${url}/lists?offset=${offset}&limit=${limit}&filter=${filter}&search=${search}&rangFilter=${rangFilter}`;
    if (status && status.length) {
        attendanceUrl += `&status=[${status}]`;
    }

    const result =  axios({
        method: 'GET',
        headers: getHeaders(),
        url: attendanceUrl,
    });
    return new Promise((resolve, reject) => {
        result
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
}

export function getOne(attendanceEntryId) {
    const result = axios({
        method: "GET",
        url: `${url}/detail/${attendanceEntryId}`,
        headers: getHeaders(),
    })
    return new Promise((resolve, reject) => {
        result
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    })
}

export function getSummary() {
    const result = axios({
        method: "GET",
        url: `${url}/summary`,
        headers: getHeaders(),
    })
    return new Promise((resolve, reject) => {
        result
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    })
}

export function insertNewRecord(data) {
    return axios({
        method: 'POST',
        url: `${url}/create`,
        headers: getHeaders(),
        data
    });
}

export function updateRecordById(id, dataToUpdate) {
    return axios({
        method: 'PUT',
        url: `${url}/update/${id}`,
        headers: getHeaders(),
        data: dataToUpdate
    });
}

export function submitTimesheet(timesheetId) {
    return axios({
        method: 'POST',
        url: `${url}/submit_timesheet/${timesheetId}`,
        headers: getHeaders()
    });
}

export function approveTimesheet(timesheetId) {
    return axios({
        method: 'POST',
        url: `${url}/approve_timesheet/${timesheetId}`,
        headers: getHeaders()
    });
}

export function softDeleteById(id) {
    return axios({
        method: "DELETE",
        url: `${url}/archive/${id}`,
        headers: getHeaders(),
    })
}